export default __webpack_public_path__ + "static/media/bg-presentation.88963029.jpg";